import { ProcedureType } from "api/type";

export const getBreastProcedures = () => {
  return [
    ProcedureType.BREAST_AUGMENTATION,
    ProcedureType.BREAST_REDUCTION,
    ProcedureType.BREAST_LIFT,
    ProcedureType.BREAST_LIFT_AND_AUGMENTATION,
  ];
};

export const getTorsoProcedures = () => {
  return [
    ProcedureType.BBL,
    ProcedureType.TUMMY_TUCK,
    ProcedureType.LIPOSUCTION,
    ProcedureType.BODY_LIFT,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.LASER_HAIR_REMOVAL,
  ];
};

export const getFaceProcedures = () => {
  return [
    ProcedureType.RHINOPLASTY,
    ProcedureType.OTOPLASTY,
    ProcedureType.FOREHEAD_LIFT,
    ProcedureType.CHIN_SURGERY,
    ProcedureType.BURN_REPAIR,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.SCAR_REVISION,
    ProcedureType.HAIR_TRANSPLANTATION,
    ProcedureType.LASER_TREATMENTS,
    ProcedureType.CHEMICAL_PEEL,
    ProcedureType.MICRODERMABRASION,
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.BLEPHAROPLASTY,
    ProcedureType.RHYTIDECTOMY,
    ProcedureType.CHEEK_AUGMENTATION,
    ProcedureType.LIP_FILLER,
  ];
};

export const getArmsProcedures = () => {
  return [
    ProcedureType.HAND_SURGERY,
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.LIPOSUCTION,
    ProcedureType.ARM_LIFT,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
    ProcedureType.HAND_SURGERY,
  ];
};

export const getLegsProcedures = () => {
  return [
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.THIGH_LIFT,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
    ProcedureType.LIPOSUCTION,
  ];
};

export const getBackProcedures = () => {
  return [
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.SCAR_REVISION,
    ProcedureType.BURN_REPAIR,
    ProcedureType.LIPOSUCTION,
    ProcedureType.BODY_LIFT,
  ];
};

export const getButtProcedures = () => {
  return [
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
    ProcedureType.BBL,
    ProcedureType.LIPOSUCTION,
    ProcedureType.BUTTOCK_AUGMENTATION,
  ];
};

export const getVaginalProcedures = () => {
  return [
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
  ];
};

export const getHeadProcedures = () => {
  return [
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.DERMAL_FILLERS,
    ProcedureType.HAIR_TRANSPLANTATION,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.BURN_REPAIR,
    ProcedureType.SCAR_REVISION,
  ];
};
